import _ from 'lodash';
/**
 * Order arrays for checkout line items display
 * Matches cost-table.jsx logic for consistency across UI
 */ // Order when discounts are applied before taxes
export var CHECKOUT_LINE_ITEMS_ORDER_DISCOUNT_PRE_TAX = [
    'productSubtotal',
    'mixAndMatch',
    'discount',
    'reward',
    'totalTax',
    'bottleDepositTaxCents',
    'cannabisTax',
    'salesTax',
    'vapourTax',
    'tip',
    'deliveryFee',
    'paymentFee',
    'otherFees',
    "roundupForCharity"
];
// Order when taxes are applied before discounts
export var CHECKOUT_LINE_ITEMS_ORDER_DISCOUNT_POST_TAX = [
    'productSubtotal',
    'mixAndMatch',
    'totalTax',
    'bottleDepositTaxCents',
    'cannabisTax',
    'salesTax',
    'vapourTax',
    'reward',
    'discount',
    'tip',
    'deliveryFee',
    'paymentFee',
    'otherFees',
    "roundupForCharity"
];
/**
 * Gets the appropriate line item display order based on dispensary tax configuration
 * @param {Object} dispensary - The dispensary object with taxConfig
 * @returns {Array<string>} - Array of line item types in display order
 */ export function getCheckoutLineItemsOrder(dispensary) {
    var _dispensary_taxConfig;
    // Determine if discounts should be applied before taxes
    var applyDiscountPreTax = _.includes([
        'both',
        'discountsFirst'
    ], dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_taxConfig = dispensary.taxConfig) === null || _dispensary_taxConfig === void 0 ? void 0 : _dispensary_taxConfig.discountTaxOrder);
    return applyDiscountPreTax ? CHECKOUT_LINE_ITEMS_ORDER_DISCOUNT_PRE_TAX : CHECKOUT_LINE_ITEMS_ORDER_DISCOUNT_POST_TAX;
}
